// @ts-nocheck

import { WebsiteApiHelper } from '@/helpers/global/baseAPI.helper';
import LocalStorageHelper from '@/helpers/global/localStorage.helper';

export const initLeadClickTracking = () => {
  const EXTERNAL_TRACKED_DOMAINS = new Set(['tutco.myshopify.com', 'www.tutcoportal.com']);
  const FORM_IDS = { phone: 9, email: 10, external: 11 };
  const RESET_PERIOD_HOURS = 24;
  const RESET_PERIOD_MS = RESET_PERIOD_HOURS * 60 * 60 * 1000;

  const hash = (str) => {
    let h = 5381;
    for (let i = 0; i < str.length; i++) h = (h << 5) + h + str.charCodeAt(i);
    return (h >>> 0).toString(16);
  };

  const shouldTrack = (key) => {
    try {
      const raw = LocalStorageHelper.getItem(`${COMPANY_UID}${key}`);
      if (!raw) return true;
      const last = Number(raw);
      if (Number.isNaN(last)) return true;
      return Date.now() - last > RESET_PERIOD_MS;
    } catch {
      return true;
    }
  };

  const markTracked = (key) => {
    LocalStorageHelper.setItem(`${COMPANY_UID}${key}`, String(Date.now()));
  };

  const sendLead = async ({ form_id, commentItem, key }) => {
    const storedVisitData = JSON.parse(LocalStorageHelper.getItem('first_visit_data') || '{}');

    const payload = {
      email: `web_click_${USER_FP.slice(0, 8)}@leads.com`,
      source_url: window.location.href,
      source_title: document.title,
      form_id,
      comment: `${commentItem} was clicked`,
      ...storedVisitData,
    };

    try {
      const response = await WebsiteApiHelper.post('/leads/', payload);
      if (response.status >= 200 && response.status < 300) {
        markTracked(key);
      }
    } catch (err) {
      console.warn('Lead click tracking failed', err);
    }
  };

  const getAnchorFromEvent = (e) => {
    const path = e.composedPath ? e.composedPath() : [];
    for (const el of path) {
      if (el && el.tagName === 'A') return el;
    }
    // fallback for browsers without composedPath
    let node = e.target;
    while (node && node !== document) {
      if (node.tagName === 'A') return node;
      node = node.parentNode;
    }
    return null;
  };

  const onClick = (e) => {
    const a = getAnchorFromEvent(e);
    if (!a) return;

    const href = (a.getAttribute('href') || '').trim();
    if (!href) return;

    // PHONE: tel:
    if (/^tel:/i.test(href)) {
      const number = href.replace(/^tel:/i, '').trim();
      if (!number) return;
      const key = `phone_number_click_${hash(number)}`;
      if (!shouldTrack(key)) return;

      void sendLead({ form_id: FORM_IDS.phone, commentItem: number, key: key });
      return;
    }

    // EMAIL: mailto:
    if (/^mailto:/i.test(href)) {
      const email = href.replace(/^mailto:/i, '').trim();
      if (!email) return;
      const key = `email_click_${hash(email.toLowerCase())}`;
      if (!shouldTrack(key)) return;
      void sendLead({ form_id: FORM_IDS.email, commentItem: email, key: key });
      return;
    }

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch {
      return;
    }

    const host = url.hostname;
    if (EXTERNAL_TRACKED_DOMAINS.has(host)) {
      const key = `external_link_click_${hash(host.toLowerCase())}`;
      if (!shouldTrack(key)) return;
      void sendLead({ form_id: FORM_IDS.external, commentItem: host, key: key });
    }
  };
  if (typeof IS_LOGGED_IN == 'undefined' || !IS_LOGGED_IN) {
    document.addEventListener('click', onClick, true);
  }
};
